import { useState, useEffect } from 'react';
import {Bounce, toast} from "react-toastify";
import {getPlantsByClient} from "../../services/Administrative/plantService";


export const useGetPlantsByClient = (uniqueCode: string) => {
    const [plants, setPlants] = useState<any[]>([]);
    const [totalPages, setTotalPages] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [page, setPage] = useState(0);

    const updatePlantLocally = (uniqueCode: string, updatedAttributes: any) => {
        setPlants((prevPlants) =>
            prevPlants.map((plant) =>
                plant.uniqueCode === uniqueCode
                    ? { ...plant, ...updatedAttributes }
                    : plant
            )
        );
    };

    const addPlantLocally = (newPlant: any) => {
        setPlants((prevPlants) => [...prevPlants, newPlant]);
    };

    useEffect(() => {
        const fetchPlants = async () => {
            setIsLoading(true);
            try {
                const response: any = await getPlantsByClient(page, uniqueCode);
                setPage(response.page);
                setPlants(response.plants);
                setTotalPages(response.totalPages);
            } catch (error: any) {
                if (error.response) {
                    if (error.response.status === 404) {
                        toast.warning(
                            `${error.response.data.message}`,
                            {
                                position: 'top-right',
                                autoClose: 5000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: false,
                                theme: 'colored',
                                transition: Bounce,
                            }
                        );
                    } else {
                        toast.error("Error al obtener los tickets.", {
                            position: 'top-right',
                            autoClose: 4000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: false,
                            theme: 'colored',
                            transition: Bounce,
                        });
                    }
                } else {
                    toast.error("Error al obtener los tickets.", {
                        position: 'top-right',
                        autoClose: 4000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: false,
                        theme: 'colored',
                        transition: Bounce,
                    });
                }
            } finally {
                setTimeout(() => {
                    setIsLoading(false);
                }, 600);
            }
        };
        fetchPlants();
    }, [page]);

    return { plants, totalPages, isLoading, page, setPage, updatePlantLocally, addPlantLocally };
};
